import React from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import Booking from "../components/Booking";
import Footer from "../components/Footer";
import Header from "../components/Header";

export default function booking() {
  Aos.init({
    duration: 900,
    offset: 100,
  });

  return (
    <div className="overflow-hidden">
      <div className="container mx-auto">
        <Header />
      </div>
      <Booking />
      <Footer />
    </div>
  );
}
